export class UpdateBonificacionRequest{
  public id?: number
  public idTipoBonificacion? :number
  public detalle?:string
}
